// extracted by mini-css-extract-plugin
export default {"others-header":"Header_others-header__Y4paP","others-header__buttons":"Header_others-header__buttons__Z8KSa"};